// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"73852cd7","389":"af3f130a","453":"dece20e0","732":"2f6a83ba","977":"92b1f042"}[chunkId] + ".chunk.js";
};